import React, { useContext } from "react";
import { FlatList, StyleSheet, View } from "react-native";
import PageTitle from "../../components/PageTitle";
import { GlobalContext } from "../../contexts/global";
import AdminMenuItem from "./components/AdminMenuItem";
import * as Colors from "../../styles/colors";

/**
 * Menu item configuration for the Admin Panel
 * Each item defines navigation target and display properties
 */
const ADMIN_MENU_ITEMS = [
  {
    id: "users",
    icon: "account-group",
    title: "Gerenciar Usuários",
    description: "Visualizar e gerenciar contas de usuários",
    screen: "AdminUserList",
  },
  {
    id: "documents",
    icon: "file-document-multiple",
    title: "Documentos de Usuários",
    description: "Visualizar documentos enviados pelos usuários",
    screen: "AdminUserDocuments",
  },
  {
    id: "wallet",
    icon: "wallet-plus",
    title: "Ajustar Carteira",
    description: "Adicionar ou remover saldo de usuários",
    screen: "AdminUserList",
    screenParams: { walletMode: true },
  },
  {
    id: "audit",
    icon: "clipboard-text-clock",
    title: "Logs de Auditoria",
    description: "Visualizar histórico de ações administrativas",
    screen: "AdminAuditLog",
  },
  {
    id: "transactions",
    icon: "receipt",
    title: "Histórico de Transações",
    description: "Visualizar todas as transações do sistema",
    screen: "AdminTransactionHistory",
  },
];

export default function AdminPanel({ navigation }) {
  const { setShowAlert, showAlert } = useContext(GlobalContext);

  /**
   * Handles menu item press
   * Navigates to the appropriate screen or shows "coming soon" alert for placeholders
   */
  const handleMenuItemPress = (item) => {
    if (item.isPlaceholder) {
      setShowAlert({
        type: "info",
        title: "Em breve",
        message: "Esta funcionalidade estará disponível em breve.",
        show: true,
        confirmText: "OK",
        pressConfirm: () => setShowAlert({ ...showAlert, show: false }),
      });
      return;
    }

    if (item.screen) {
      navigation.navigate(item.screen, item.screenParams || {});
    }
  };

  const renderMenuItem = ({ item }) => (
    <AdminMenuItem
      icon={item.icon}
      title={item.title}
      description={item.description}
      isPlaceholder={item.isPlaceholder}
      onPress={() => handleMenuItemPress(item)}
    />
  );

  return (
    <PageTitle title={"Painel Admin"} navigation={navigation}>
      <View style={styles.container}>
        <FlatList
          data={ADMIN_MENU_ITEMS}
          renderItem={renderMenuItem}
          keyExtractor={(item) => item.id}
          contentContainerStyle={styles.listContent}
        />
      </View>
    </PageTitle>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.WHITE,
  },
  listContent: {
    paddingTop: 8,
  },
});
